import logo from './logo.svg';
import './App.css';
import Header from "./Components/Header/Header"
import Hero from './Components/Hero/Hero';
import Network_overview from './Components/Network_overview/Network_overview';
import Pool_sec from './Components/Pool_sec/Pool_sec';
import Stake from './Components/Stake/Stake';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <div className="">
       <Toaster />
      <Header />
      <Hero />
      <Network_overview />
      <Pool_sec />
      <Stake />
    </div>
  );
}

export default App;
